// Mixins
import confirmDialogMixin from '@/mixins/cd.mixin.js'

// Componentes
import SosButton from '@/components/SosButton'
import SosSelect from '@/components/SosSelect'

// Dialogs
import ConfirmDialog from '@/modals/ConfirmDialog'
import DialogFindPatient from '@/modals/DialogFindPatient'
import DialogFindGroup from '@/modals/DialogFindGroup'

import { apiRetrievePatientDoctorsAndLastAttenderAvailability, apiGetPatient, apiGetReminder, buildPatientLocationMessage, buildPatientName, buildPatientUnitAddress, buildPatientLocation, apiUpdateAppointment, apiDeleteAppointment } from '@/services/consultations'
import { apiGetUserId } from '@/services/firebase'

// Imagens
import dutyStatusCancelado from '@/assets/images/duty-status-cancelado.png'

// .
import { mapState } from 'vuex'

//
//
//

const attendanceOptions = [
  {
    key: 'attendance_none',
    value: '',
    rawText: 'Não informado',
    formattedText: '<span><i class="mdi mdi-help-circle attendancePending__icon" aria-hidden="true"></i><span class="attendancePending">Não informado</span></span>',
    text: 'Não informado',
  },
  {
    key: 'attendance_0',
    value: '0',
    rawText: 'Não',
    formattedText: '<span><i class="mdi mdi-account-off attendanceNo__icon" aria-hidden="true"></i><span class="attendanceNo">Não</span></span>',
    text: 'Não',
  },
  {
    key: 'attendance_1',
    value: '1',
    rawText: 'Sim',
    formattedText: '<span><i class="mdi mdi-account-check attendanceYes__icon" aria-hidden="true"></i><span class="attendanceYes">Sim</span></span>',
    text: 'Sim',
  },
]

//
//
//

const typesOfMedicalCare = [
  {
    key: 'type_of_medical_care_0',
    value: '0',
    rawText: 'Escolha uma opção antes de atualizar a consulta',
    formattedText: '<span class="typeOfMedicalCare--empty">Escolha uma opção antes de atualizar a consulta</span>',
    text: 'Escolha uma opção antes de atualizar a consulta',
  },
  {
    key: 'type_of_medical_care_1',
    value: '1',
    rawText: 'Presencial',
    formattedText: '<span><i class="mdi mdi-home-account typeOfMedicalCare__icon" aria-hidden="true"></i><span class="typeOfMedicalCare">Presencial</span></span>',
    text: 'Presencial',
  },
  {
    key: 'type_of_medical_care_2',
    value: '2',
    rawText: 'Remoto',
    formattedText: '<span><i class="mdi mdi-laptop-account typeOfMedicalCare__icon" aria-hidden="true"></i><span class="typeOfMedicalCare">Remoto</span></span>',
    text: 'Remoto',
  },

  // { text: '<b style="color: red;text-shadow: 0px 0px 10px rgba(255, 255, 0, 0.3)">Escolha uma opção antes de atualizar a consulta</b>', value: '0', disabled: true, divider: false },
  // { text: 'Presencial', value: '1', disabled: false, divider: false },
  // { text: 'Remoto', value: '2', disabled: false, divider: false },
]

//
//
//

const optionDefault = '<div class="appointmentdoctor__item"><i aria-hidden="true" class="mdi mdi-account-group appointmentdoctor__item__icon"></i><span class="appointmentdoctor__item__text">Qualquer profissional (<span class="itemTextBold">Opção padrão</span>)</span></div>'

const optionAny = {
  key: 'any',
  value: '',
  rawText: 'Qualquer profissional',
  formattedText: optionDefault,
  text: 'Qualquer profissional (Opção padrão)',
  profile: null,
  // checked: true,
}

//
//
//

export default {
  name: 'DetalhesDaConsulta',

  components: {
    'sos-select': SosSelect,
    'sos-button': SosButton,
    'confirm-dialog': ConfirmDialog,
    'dialog-find-patient': DialogFindPatient,
    'dialog-find-group': DialogFindGroup,
  },

  mixins: [
    confirmDialogMixin,
  ],

  data () {
    return {
      // STATUS DO DIALOG
      isDialogVisible: false,

      // STATUS DAS OPERAÇÕES EM RELAÇÃO AO DIALOG (ou o contrário)
      isLoading: true,

      // ?
      isCurrentUserMunicipalityValid: 'loading',

      //
      // INFORMAÇÃO VISÍVEL NA TELA
      //

      // INCLUSÃO DE PACIENTE OBRIGATÓRIA
      patientRequired: true,

      // Nome / Escala
      plantaoEscalaID: '',
      plantaoEscalaNome: '',

      // Plantonista
      ownerID: '0',
      campoPlantonistaSelecionado: '0',
      campoPlantonistaOpcoes: [],

      // Observação
      campoObservacao: '',
      obs: '',

      //
      //
      //

      startTimestamp: 0,
      consultationID: '',
      consultationDate: '',
      consultationStartTime: '',
      consultationEndTime: '',
      consultationDuration: '',

      // Tipos de comparecimento
      attendanceOptions,

      // Tipos de consulta
      typesOfMedicalCare,

      // Pacientes selecionados
      fieldPatientId: '',
      backupPatientId: '',
      patients: {},

      // Reminder
      reminderId: '',
      hasReminder: false,
      reminderStatus: 'WAITING', // WAITING, ERROR, NO, ACTIVE and CANCELED
      reminderError: '',

      requireSosPortalAppointmentKeys: false,
    }
  },

  computed: {
    //
    //
    //

    ...mapState(['group', 'groupUsers', 'userSession']),

    //
    //
    //

    // Consultation already have a patient defined
    withPatient: function () {
      return !!this.backupPatientId === true
    },

    // Patient is selected or not
    patientSelected: function () {
      return !!this.fieldPatientId === true
    },

    isPatientSet: function () {
      return this.patientSelected === true && this.withPatient === true
    },

    //
    //
    //

    activePatient: function () {
      return !!this.fieldPatientId === true && !!this.patients === true && !!this.patients[this.fieldPatientId] === true ? this.patients[this.fieldPatientId] : null
    },

    defaultPatient: function () {
      return !!this.backupPatientId === true && !!this.patients === true && !!this.patients[this.backupPatientId] === true ? this.patients[this.backupPatientId] : null
    },

    //
    //
    //

    fieldTypeOfMedicalCare: function () {
      // return !!this.activePatient === true && !!this.activePatient.fieldTypeOfMedicalCare === true ? this.activePatient.fieldTypeOfMedicalCare : ''
      return !!this.fieldPatientId === true && !!this.patients === true && !!this.patients[this.fieldPatientId] === true && !!this.patients[this.fieldPatientId].fieldTypeOfMedicalCare === true ? this.patients[this.fieldPatientId].fieldTypeOfMedicalCare : '0'
    },

    fieldPatientAttendance: function () {
      // return !!this.activePatient === true && !!this.activePatient.fieldPatientAttendance === true ? this.activePatient.fieldPatientAttendance : ''
      return !!this.fieldPatientId === true && !!this.patients === true && !!this.patients[this.fieldPatientId] === true && !!this.patients[this.fieldPatientId].fieldPatientAttendance === true ? this.patients[this.fieldPatientId].fieldPatientAttendance : ''
    },

    //
    //
    //

    typeOfMedicalCareName: function () {
      return !!this.activePatient === true ? (
        this.activePatient.fieldTypeOfMedicalCare === '0' ? (
          '<span class="typeOfMedicalCare--empty">Escolha uma opção antes de atualizar a consulta</span>'
        ) : (
          this.activePatient.fieldTypeOfMedicalCare === '1' ? (
            '<i class="mdi mdi-home-account typeOfMedicalCare__icon" aria-hidden="true"></i><span class="typeOfMedicalCare">Presencial</span>'
          ) : (
            this.activePatient.fieldTypeOfMedicalCare === '2' ? (
              '<i class="mdi mdi-laptop-account typeOfMedicalCare__icon" aria-hidden="true"></i><span class="typeOfMedicalCare">Remoto</span>'
            ) : (
              'Desconhecido'
            )
          )
        )
      ) : ''
    },

    attendanceName: function () {
      return !!this.activePatient === true ? (
        this.activePatient.fieldPatientAttendance === '0' ? (
          '<i class="mdi mdi-account-off attendanceNo__icon" aria-hidden="true"></i><span class="attendanceNo">Não</span>'
        ) : (
          this.activePatient.fieldPatientAttendance === '1' ? (
            '<i class="mdi mdi-account-check attendanceYes__icon" aria-hidden="true"></i><span class="attendanceYes">Sim</span>'
          ) : '<i class="mdi mdi-help-circle attendancePending__icon" aria-hidden="true"></i><span class="attendancePending">Não informado</span>'
        )
      ) : ''
    },

    //
    //
    //

    updateConsultationDisabledStatus: function ()
    {
      return (
        // Sem permissão para trabalhar com o município selecionado ??? JESUS: Confirmar
        this.isCurrentUserMunicipalityValid === 'no' ||

        // Não deve estar carregando
        this.isLoading ||

        // Se o reminder existir, o status não pode ser WAITING, ERROR ou LOADING
        (
          this.hasReminder === true &&
          this.reminderStatus !== 'NO' &&
          this.reminderStatus !== 'ACTIVE' &&
          this.reminderStatus !== 'CANCELED'
        ) ||

        // O PACIENTE É OBRIGATÓRIO? ELE DEVE ESTAR SELECIONADO
        (
          this.patientRequired === true &&
          this.patientSelected === false
        ) ||

        // PACIENTE SELECIONADO? O TIPO DE CONSULTA NÃO PODE SER "Escolha uma opção antes de atualizar a consulta"
        (
          // this.patientSelected === true &&

          !!this.activePatient === true &&
          this.activePatient.fieldTypeOfMedicalCare === '0'
        ) ||

        // ALGUM DOS CAMPOS DEVE TER SIDO ALTERADO: MUNICÍPIO, OBSERVAÇÃO, PACIENTE, TIPO DE CONSULTA e COMPARECIMENTO (DO PACIENTE)
        (
          // !this.changedOwner &&
          (String(this.campoPlantonistaSelecionado).trim() === String(this.ownerID).trim()) &&

          // !this.changedObservation &&
          (this.cleanedObs === String(this.obs).trim()) &&

          // !this.changedPatient
          (this.fieldPatientId === this.backupPatientId) &&

          // Mudou médico
          // (this.selectedDoctorId === this.backupDoctorId) &&

          // !this.changedAttendance &&
          (
            /* PACIENTE NÃO OBRIGATÓRIO */
            (this.patientRequired === false && !!this.activePatient === false) ||
            /* PACIENTE NÃO OBRIGATÓRIO E OBRIGATÓRIO */
            (!!this.activePatient === true && this.activePatient.fieldPatientAttendance === this.activePatient.backupPatientAttendance)
          ) &&

          // !this.changedTypeOfMedicalCare &&
          (
            /* PACIENTE NÃO OBRIGATÓRIO */
            (this.patientRequired === false && !!this.activePatient === false) ||
            /* PACIENTE NÃO OBRIGATÓRIO E OBRIGATÓRIO */
            (!!this.activePatient === true && String(this.activePatient.fieldTypeOfMedicalCare).trim() === String(this.activePatient.backupTypeOfMedicalCare).trim())
          )
        )
      )
    },

    deleteConsultationDisabledStatus: function () {
      return this.isLoading || (this.hasReminder === true && this.reminderStatus !== 'NO' && this.reminderStatus !== 'ACTIVE' && this.reminderStatus !== 'CANCELED')
    },

    findPatientDisabledStatus: function () {
      return (
        // ?
        this.isCurrentUserMunicipalityValid === 'no' ||
        // Não deve estar carregando
        this.isLoading ||
        // Se o reminder existir, o status não pode ser WAITING, ERROR ou LOADING
        (
          this.hasReminder === true &&
          this.reminderStatus !== 'NO' &&
          this.reminderStatus !== 'ACTIVE' &&
          this.reminderStatus !== 'CANCELED'
        )
      )
    },

    dettachmentDisabledStatus: function () {
      return (
        // ?
        this.isCurrentUserMunicipalityValid === 'no' ||
        // Não deve estar carregando
        this.isLoading ||
        // Se o reminder existir, o status não pode ser WAITING, ERROR ou LOADING
        (
          this.hasReminder === true &&
          this.reminderStatus !== 'NO' &&
          this.reminderStatus !== 'ACTIVE' &&
          this.reminderStatus !== 'CANCELED'
        ) ||
        // Paciente não selecionado pelo usuário
        this.patientSelected === false
      )
    },

    //
    //
    //

    reminderStatusName: function ()
    {
      const r = this.reminderStatus || 'WAITING'

      // console.log('reminderStatusName:', r)

      return r === 'WAITING' || r === 'LOADING' ? (
        'Carregando...'
      ) : (
        r === 'ERROR' ? (
          this.reminderError || '<b style="color: indianred">Não foi possível conferir o status</b>'
        ) : (
          r === 'NO' ? (
            '<span><i class="mdi mdi-bell-off attendancePending__icon" aria-hidden="true"></i><span class="attendancePending">Nunca foi iniciado</span></span>'
          ) : (
            r === 'ACTIVE' ? (
              '<span><i class="mdi mdi-bell-ring attendanceYes__icon" aria-hidden="true"></i><span class="attendanceYes">Ativado</span></span>'
            ) : (
              r === 'CANCELED' ? (
                '<span><i class="mdi mdi-bell-off attendanceYes__icon" aria-hidden="true"></i><span class="attendanceYes">O lembrete existe e está cancelado!</span></span>'
              ) : (
                '<b style="color: indianred">Desconhecido</b>'
              )
            )
          )
        )
      )
    },

    //
    //
    //

    cleanedObs: function () {
      return !!this.campoObservacao === true ? String(this.campoObservacao).trim() : ''
    },

    //
    //
    //

    changedOwner: function () {
      return String(this.campoPlantonistaSelecionado).trim() !== String(this.ownerID).trim()
    },

    changedObservation: function () {
      return this.cleanedObs !== String(this.obs).trim()
    },

    changedPatient: function () {
      return this.fieldPatientId.length > 0 && this.backupPatientId.length > 0 && this.fieldPatientId !== this.backupPatientId
    },

    changedTypeOfMedicalCare: function () {
      return !!this.activePatient === true && String(this.activePatient.fieldTypeOfMedicalCare).trim() !== String(this.activePatient.backupTypeOfMedicalCare).trim()
    },

    /* changedRegulationCode: function () {
      return !!this.activePatient === true && String(this.activePatient.fieldRegulationCode).trim() !== String(this.activePatient.backupRegulationCode).trim()
    },

    changedConfirmationKey: function () {
      return !!this.activePatient === true && String(this.activePatient.fieldConfirmationKey).trim() !== String(this.activePatient.backupConfirmationKey).trim()
    }, */

    changedAttendance: function () {
      return !!this.activePatient === true && this.activePatient.fieldPatientAttendance !== this.activePatient.backupPatientAttendance
    },
  },

  watch: {
    //
    //
    //

    /* defaultPatient: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (currentState, previousState)
      {
        // [06/02/25] console.log('::: defaultPatient:', currentState, previousState)
      },
    }, */

    //
    //
    //

    /* activePatient: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (currentState, previousState)
      {
        // [06/02/25] console.log('::: activePatient:', currentState, previousState)
      },
    }, */

    //
    //
    //

    isDialogVisible: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (currentVisibility, oldVisibility)
      {
        if (!!currentVisibility === false) this.clear()
      },
    },

    //
    //
    //

    /* fieldPatientAttendance: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      handler (newAttendanceStatus, oldAttendanceStatus)
      {
        // [06/02/25] console.log('::: WATCH > fieldPatientAttendance:', newAttendanceStatus)
      },
    }, */

    //
    // JESUS: Necessário?
    // JESUS: Necessário?
    // JESUS: Necessário?
    //

    patients: {
      // the callback will be called immediately after the start of the observation
      immediate: true,
      // Deep
      deep: true,
      // ?
      handler (newPatients, oldPatients)
      {
        if (!!this.fieldPatientId === true && !!this.patients[this.fieldPatientId] === true)
        {
          const newStatus = newPatients[this.fieldPatientId].fieldTypeOfMedicalCare
          const oldStatus = oldPatients[this.fieldPatientId].fieldTypeOfMedicalCare

          // O campos precisa estar carregado com valores válidos
          if (
            typeof newStatus === 'string' &&
            (newStatus === '0' || newStatus === '1' || newStatus === '2') &&
            typeof oldStatus === 'string' &&
            (oldStatus === '0' || oldStatus === '1' || oldStatus === '2')
          )
          {
            if (newStatus === '1' && newStatus !== oldStatus /* JESUS: Testar */)
            {
              this.patients[this.fieldPatientId].fieldPatientUnitId = this.patients[this.fieldPatientId].backupPatientUnitId
              this.patients[this.fieldPatientId].fieldPatientUnitName = this.patients[this.fieldPatientId].backupPatientUnitName
              this.patients[this.fieldPatientId].fieldPatientUnitAddress = this.patients[this.fieldPatientId].backupPatientUnitAddress
              // this.fieldPatientAttendance = this.backupPatientAttendance
              this.patients[this.fieldPatientId].fieldRegulationCode = this.patients[this.fieldPatientId].backupRegulationCode
              this.patients[this.fieldPatientId].fieldConfirmationKey = this.patients[this.fieldPatientId].backupConfirmationKey

              //

              this.patients[this.fieldPatientId].backupPatientUnitId = ''
              this.patients[this.fieldPatientId].backupPatientUnitName = ''
              this.patients[this.fieldPatientId].backupPatientUnitAddress = ''
              // this.backupPatientAttendance = ''
              this.patients[this.fieldPatientId].backupRegulationCode = ''
              this.patients[this.fieldPatientId].backupConfirmationKey = ''
            }

            if (newStatus !== '1' && oldStatus === '1')
            {
              this.patients[this.fieldPatientId].backupPatientUnitId = this.patients[this.fieldPatientId].fieldPatientUnitId
              this.patients[this.fieldPatientId].backupPatientUnitName = this.patients[this.fieldPatientId].fieldPatientUnitName
              this.patients[this.fieldPatientId].backupPatientUnitAddress = this.patients[this.fieldPatientId].fieldPatientUnitAddress
              // this.backupPatientAttendance = this.fieldPatientAttendance
              this.patients[this.fieldPatientId].backupRegulationCode = this.patients[this.fieldPatientId].fieldRegulationCode
              this.patients[this.fieldPatientId].backupConfirmationKey = this.patients[this.fieldPatientId].fieldConfirmationKey

              //

              this.patients[this.fieldPatientId].fieldPatientUnitId = ''
              this.patients[this.fieldPatientId].fieldPatientUnitName = ''
              this.patients[this.fieldPatientId].fieldPatientUnitAddress = ''
              // this.fieldPatientAttendance = ''
              this.patients[this.fieldPatientId].fieldRegulationCode = ''
              this.patients[this.fieldPatientId].fieldConfirmationKey = ''
            }
          }
        }
      },
    },
  },

  /* mounted () {
    // [06/02/25] console.log('::: DUTY MODAL:', this.groupUsers)
  }, */

  methods: {
    //
    //
    //

    async open (appointmentDetails)
    {
      // DEBUG
      console.log('::: [DEBUG] APPOINTMENT EDIT MODAL:', appointmentDetails)

      // Sinaliza carregamento para o dialog
      this.isLoading = true

      // Abre o dialog
      // this.isDialogVisible = true

      // INCLUSÃO DE PACIENTE OBRIGATÓRIA
      this.patientRequired = appointmentDetails.patientRequired

      // Escala
      this.plantaoEscalaID = appointmentDetails.scaleID
      this.plantaoEscalaNome = appointmentDetails.scaleName

      //
      //
      //

      const groupUsers = !!this.$store.state.group === true && !!this.$store.state.group.users === true ? this.$store.state.group.users : false
      const isAdmin = !!groupUsers === true ? Object.fromEntries(Object.keys(groupUsers).map(userID => ([userID, groupUsers[userID].admin || false])).filter(check => !!check === true)) : null

      const me = this.groupUsers.find(user => user.userID === this.userSession.uid)
      const myMunicipalities = !!me === true ? this.groupUsers.filter(user => !!isAdmin === true && !!isAdmin[user.userID] === true && user.isMunicipality === true && (!!me.userMunicipalities === false || (!!me.userMunicipalities === true && !!me.userMunicipalities[user.userID] === true))) : []

      /* // const groupManagers = this.groupUsers
      const groupManagers = this.groupUsers.filter(user => !!isAdmin === true && !!isAdmin[user.userID] === true)
      // como fica se o usuário logado não for mais um gestor? Município pode mudar? <<<

      const me = groupManagers.find(user => user.userID === this.userSession.uid)
      const myMunicipalities = !!me === true ? groupManagers.filter(user => user.isMunicipality === true && (!!me.userMunicipalities === false || (!!me.userMunicipalities === true && !!me.userMunicipalities[user.userID] === true))) : []
      // se deixar de ser gestor, continuar sendo município e continuar vinculado ao GESTOR LOGADO... vai aparecer como NÃO RELACIONADO (mesmo estando relacionado) */

      //

      const isOwnerInvalidMunicipality = appointmentDetails.municipalityID !== '0' && myMunicipalities.some(m => String(m.userID) === String(appointmentDetails.municipalityID)) === false

      let selecionado = isOwnerInvalidMunicipality ? this.groupUsers.filter(user => String(user.userID) === String(appointmentDetails.municipalityID)) : []

      selecionado = selecionado.length > 0 ? selecionado.map(user => ({
        image: user.userImage,
        text: `<span class="consultationName">${user.userName}</span>${user.isMunicipality && !!isAdmin === true && !!isAdmin[user.userID] === true ? '' : ' <span class="consultationNotice">NÃO É MUNICÍPIO E GESTOR</span>'}${!!me.userMunicipalities === true && !!me.userMunicipalities[user.userID] === false ? ' <span class="consultationNotice consultationNotice--manager">NÃO RELACIONADO</span>' : ''}`,
        value: String(user.userID),
        disabled: true,
        divider: false,
      })) : null

      this.isCurrentUserMunicipalityValid = isOwnerInvalidMunicipality ? (!!me.userMunicipalities === false ? 'yes' : 'no') : 'yes'

      //
      //
      //

      // tratar usuário que está selecionado, mas não é mais válido (município ou gestor)
      // poderá selecionar?

      let campoPlantonistaOpcoes = []
      // NENHUM
      campoPlantonistaOpcoes.push({ image: dutyStatusCancelado, text: 'Nenhum', value: '0', disabled: this.isCurrentUserMunicipalityValid !== 'yes', divider: false })
      // SELECIONADO
      if (!!selecionado === true) campoPlantonistaOpcoes.push(...selecionado)
      // USUÁRIOS
      campoPlantonistaOpcoes = [
        ...campoPlantonistaOpcoes,
        ...myMunicipalities.map(user => ({
          image: user.userImage,
          text: `<span class="consultationName">${user.userName}</span>${user.isMunicipality && !!isAdmin === true && !!isAdmin[user.userID] === true ? '' : ' <span class="consultationNotice">NÃO É MUNICÍPIO E GESTOR</span>'}`,
          value: String(user.userID),
          disabled: this.isCurrentUserMunicipalityValid !== 'yes',
          // disabled: isOwnerInvalidMunicipality || (user.isMunicipality && !!isAdmin === true && !!isAdmin[user.userID] === true) === false,
          // disabled: isOwnerInvalidMunicipality,
          divider: false,
        })),
      ]

      // OPÇÕES DE USUÁRIOS
      this.campoPlantonistaOpcoes = campoPlantonistaOpcoes

      // ?
      this.campoObservacao = appointmentDetails.observation
      this.obs = appointmentDetails.observation

      // ?
      this.campoPlantonistaSelecionado = appointmentDetails.municipalityID
      this.ownerID = appointmentDetails.municipalityID

      // ?
      this.startTimestamp = appointmentDetails.timestamp
      this.consultationID = appointmentDetails.id
      this.consultationDate = appointmentDetails.date
      this.consultationStartTime = appointmentDetails.startTime
      this.consultationEndTime = appointmentDetails.endTime
      this.consultationDuration = appointmentDetails.duration

      //
      //
      //

      const patientID = appointmentDetails.patientID
      const patientFirstName = appointmentDetails.patientFirstName
      const patientLastName = appointmentDetails.patientLastName

      this.fieldPatientId = patientID
      this.backupPatientId = patientID

      this.reminderId = appointmentDetails.reminderId

      this.patients[patientID] = {
        currentPatientName: buildPatientName(patientFirstName, patientLastName),
        patientFirstName,
        patientLastName,
        patientDateOfBirth: appointmentDetails.patientDateOfBirth,
        patientEmail: appointmentDetails.patientEmail,
        patientCpf: appointmentDetails.patientCpf,
        patientGroup: appointmentDetails.patientUnitName,

        fieldRegulationCode: appointmentDetails.regulationCode,
        fieldConfirmationKey: appointmentDetails.confirmationKey,

        fieldTypeOfMedicalCare: appointmentDetails.locationType,
        fieldPatientUnitId: appointmentDetails.locationID,
        fieldPatientUnitName: appointmentDetails.locationName,
        fieldPatientUnitAddress: appointmentDetails.locationAddress,
        fieldPatientAttendance: appointmentDetails.attendanceStatus,
        fieldDoctorId: appointmentDetails.doctorID,
        fieldDoctorName: '', // JESUS: Testar
        fieldDoctorProfile: appointmentDetails.doctorID.length > 0 ? {
          id: appointmentDetails.doctorID,
          name: appointmentDetails.doctorName,
        } : null,

        //

        doctorsStatus: 'WAITING',
        doctorsStatusMessage: '',
        selectDoctors: [optionAny],
        fieldDoctorError: false,

        //

        backupRegulationCode: appointmentDetails.regulationCode,
        backupConfirmationKey: appointmentDetails.confirmationKey,

        backupTypeOfMedicalCare: appointmentDetails.locationType,
        backupPatientUnitId: appointmentDetails.locationID,
        backupPatientUnitName: appointmentDetails.locationName,
        backupPatientUnitAddress: appointmentDetails.locationAddress,
        backupPatientAttendance: appointmentDetails.attendanceStatus,
        backupDoctorId: appointmentDetails.doctorID,
        backupDoctorProfile: appointmentDetails.doctorID.length > 0 ? {
          id: appointmentDetails.doctorID,
          name: appointmentDetails.doctorName,
        } : null,
      }

      this.requireSosPortalAppointmentKeys = this.$store.state?.group?.requireSosPortalAppointmentKeys || false

      //
      //
      //

      // ABRE O DIALOG
      this.isDialogVisible = true

      // REMINDER
      await this.refreshPatientReminder(this.reminderId)

      // FETCH / RETRIEVE PATIENT DOCTORS FOR SPECIALTY
      await this.refreshPatientDoctors(patientID, appointmentDetails.scaleID)

      // AVISA A UI QUE TERMINOU DE CARREGAR
      this.isLoading = false

      // console.log('::: OPEN:', this.reminderStatus, this.defaultPatient, this.activePatient)
    },

    //
    //
    //

    closeDialog ()
    {
      if (this.isLoading) return

      this.isDialogVisible = false
    },

    //
    //
    //

    openFindPatientDialog ()
    {
      this.$refs.modalFindPatient.open()
    },

    //
    //
    //

    openFindGroupDialog ()
    {
      if (
        this.isLoading ||
        // this.isPatientSet === true ||
        (this.patientRequired === false && this.isPatientSet === true) ||
        (this.patientRequired === true && this.isPatientSet === true && this.changedPatient === false) ||
        this.activePatient.fieldTypeOfMedicalCare !== '1'
      ) return false

      this.$refs.modalFindGroup.open()
    },

    //
    //
    // SEARCH GROUP DIALOG RESPONSE
    //
    //

    dialogSearchGroupAction (cdResponse)
    {
      const fieldPatientUnitId = cdResponse.groupId || ''
      const fieldPatientUnitName = cdResponse.groupName || ''

      if (fieldPatientUnitId !== this.patients[this.fieldPatientId].fieldPatientUnitId) {
        this.patients[this.fieldPatientId].fieldPatientUnitId = fieldPatientUnitId
        this.patients[this.fieldPatientId].fieldPatientUnitName = fieldPatientUnitName

        this.patients[this.fieldPatientId].fieldPatientUnitAddress = ''
        this.patients[this.fieldPatientId].backupPatientUnitAddress = ''

        this.patients = { ...this.patients } // JESUS: Necessário?
      }
    },

    //
    //
    //
    // REMOVE PATIENT BUTTON
    //
    //
    //

    confirmDetachPatient ()
    {
      // Patient profile (If there/it exists)
      this.fieldPatientId = ''

      if (this.withPatient === true && this.patientRequired === false) {
        this.showMessage('IMPORTANTE!', `Clique em <b>ATUALIZAR CONSULTA</b> para desmarcar a consulta com <b style="color: dodgerblue">${this.defaultPatient.currentPatientName}</b>.`)
      }
    },

    //
    //
    //
    // LIMPEZA DO STATE DO COMPONENTE
    //
    //
    //

    clear ()
    {
      // CAIXA DE MENSAGEM
      this.cdParameters = { title: '', text: '', buttonPosition: 'right', width: 330 }

      // STATUS DO DIALOG
      // this.isDialogVisible = false

      // STATUS DAS OPERAÇÕES EM RELAÇÃO AO DIALOG (ou o contrário)
      this.isLoading = true

      //
      // INFORMAÇÃO VISÍVEL NA TELA
      //

      // INCLUSÃO DE PACIENTE OBRIGATÓRIA
      this.patientRequired = true

      // Nome / Escala
      this.plantaoEscalaID = ''
      this.plantaoEscalaNome = ''

      // Plantonista
      this.ownerID = '0'
      this.campoPlantonistaSelecionado = '0'
      this.campoPlantonistaOpcoes = []

      // ?
      this.campoObservacao = ''
      this.obs = ''

      // ?
      this.startTimestamp = 0
      this.consultationID = ''
      this.consultationDate = ''
      this.consultationStartTime = ''
      this.consultationEndTime = ''
      this.consultationDuration = ''

      // ?
      this.fieldPatientId = ''
      this.backupPatientId = ''
      this.patients = {}

      // Reminder
      this.reminderId = ''
      this.hasReminder = false
      this.reminderStatus = 'WAITING'
      this.reminderError = ''

      this.requireSosPortalAppointmentKeys = false
    },

    //
    //
    //
    // ?
    //
    //
    //

    async refreshPatientReminder (reminderID)
    {
      const hasReminder = !!reminderID === true

      this.hasReminder = hasReminder
      this.reminderStatus = hasReminder ? 'LOADING' : 'NO'
      this.reminderError = ''

      if (!hasReminder) {
        return false
      }

      const x = await apiGetReminder({ viewerID: apiGetUserId(), reminderID, groupID: this.$route.params.groupID })

      this.reminderStatus = x.httpCode === 200 && Object.prototype.hasOwnProperty.call(x.data || {}, 'canceled') ? (
        x.message.canceled === true ? 'CANCELED' : 'ACTIVE'
      ) : (
        'ERROR'
      )

      this.reminderError = x.httpCode !== 200 ? x.message : ''
    },

    //
    //
    //
    // ?
    //
    //
    //

    async refreshPatientDoctors (patientID, specialtyID)
    {
      const couldRefresh = !!patientID === true && !!specialtyID === true && !!this.patients[patientID] === true

      if (!couldRefresh) return false

      // this.patients[patientID].doctorsStatus = couldRefresh ? 'LOADING' : 'DONE'
      this.patients[patientID].doctorsStatus = 'LOADING'

      const [day, month, year] = (this.consultationDate || '').split('/')
      const startDateTime = `${year}-${month}-${day}T${this.consultationStartTime || ''}`
      const request = await apiRetrievePatientDoctorsAndLastAttenderAvailability({ viewerID: apiGetUserId(), patientID, specialtyID, groupID: this.$route.params.groupID, datetime: startDateTime, screen: 'EDIT' })

      if (request.httpCode !== 200) {
        this.patients[patientID].doctorsStatus = 'ERROR'
        this.patients[patientID].doctorsStatusMessage = request.message || 'Não foi possível carregar médicos.'
        this.patients[patientID].selectDoctors = [optionAny]
        this.patients[patientID].fieldDoctorId = ''
        this.patients[patientID].fieldDoctorName = optionDefault
        this.patients[patientID].fieldDoctorProfile = null
        return false
      }

      this.patients[patientID].doctorsStatus = 'DONE'
      this.patients[patientID].doctorsStatusMessage = ''

      this.patients[patientID].selectDoctors = [
        optionAny,
        ...request.message.map(d => {
          const fullname = String(d.name || '')
          const firstname = fullname.split(' ')[0] || ''

          const lastAttenderCurrentSlotAvailability = d.in_scale || null

          const status = d.last_attender ? (lastAttenderCurrentSlotAvailability ? 'ACTIVE' : 'INACTIVE') : 'REGULAR'

          const doctorSelected = this.patients[patientID]?.backupDoctorId === d.external_id
          const selected = d.last_attender || doctorSelected

          const icon = selected ? 'stethoscope' : 'account'
          const iconColor = selected ? 'appointmentdoctor__item__icon--active' : 'appointmentdoctor__item__icon--normal'
          const textColor = selected ? 'appointmentdoctor__item__text--active' : 'appointmentdoctor__item__text--normal'

          const doctorName = doctorSelected ? `${fullname} (<span class="itemTextBold">Atual</span>)` : fullname

          const name = d.last_attender ? `${doctorName} (<span class="itemTextBold">Último atendimento</span>)` : doctorName

          return {
            key: `doctor_${d.external_id}`,
            value: d.external_id,
            rawText: fullname,
            formattedText: `<div class="appointmentdoctor__item"><i aria-hidden="true" class="mdi mdi-${icon} appointmentdoctor__item__icon ${iconColor}"></i><span class="appointmentdoctor__item__text ${textColor}">${name}</span></div>`,
            text: fullname,
            profile: !!d === true ? {
              slots: (d.slots || []).length,
              status,
              in_scale: lastAttenderCurrentSlotAvailability,
              last: d.last_attender || false,
              id: String(d.external_id || ''),
              name: fullname,
              firstname,
            } : null,
            // checked: true,
          }
        })
      ]

      //
      // JESUS
      //

      // this.patients[patientID].fieldDoctorError = !!this.patients[patientID].backupDoctorId === true && !this.patients[patientID].selectDoctors.some(x => !!x.profile === true && String(x.profile.id || '') === this.patients[patientID].backupDoctorId)

      if (!!this.patients[patientID].backupDoctorId === true)
      {
        this.patients[patientID].fieldDoctorError = /* !!this.patients[patientID].backupDoctorId === true && */ !this.patients[patientID].selectDoctors.some(x => !!x.profile === true && String(x.profile.id || '') === this.patients[patientID].backupDoctorId)

        // O PROFISSIONAL REGISTRADO NO BANCO DE DADOS NÃO FOI ENCONTRADO NO SOS PORTAL?
        // ENTÃO SELECIONA A OPÇÃO "QUALQUER PROFISSIONAL",
        // CASO CONTRÁRIO, SELECIONA O PROFISSIONAL

        this.onDoctorSelect(this.patients[patientID].backupDoctorId)

        // this.onDoctorSelect(this.patients[patientID].fieldDoctorError ? '' : this.patients[patientID].backupDoctorId)
      }
      else
      {
        this.onDoctorSelect('')
      }
    },

    //
    //
    //
    // ?
    //
    //
    //

    async updateConsultation ()
    {
      if (this.isLoading) return false

      //
      //
      //
      // Confirma exclusão da consulta se não houver município selecionado
      //
      //
      //

      if (this.campoPlantonistaSelecionado === '0') {
        return this.showConfirmBox({
          title: 'Atenção!',
          text: '<b>A consulta está sem município e por isso ela será apagada!</b><br /><br />Você pode VOLTAR e selecionar um município ou continuar e liberar esse horário para outro município.<br /><br/>Você confirma a exclusão dessa consulta?',
          type: 'delete-consultation',
          data: '',
          isResponse: false,
          buttonPosition: 'right',
          width: 480,
          closeText: 'Voltar',
          continueText: 'Sim, apague a consulta!',
        })
      }

      //
      //
      //
      // EXIGIR CAMPOS NECESSÁRIOS ANTES DE SALVAR
      //
      //
      //

      //
      // Deve selecionar um paciente se a especialidade (escala) REQUER UM
      //

      if (this.patientRequired === true && this.patientSelected === false) {
        return this.showMessage('Atenção!', 'Selecione um paciente.')
      }

      //
      // Deve selecionar o TIPO DE ATENDIMENTO
      //

      if (this.patientSelected === true && this.activePatient.fieldTypeOfMedicalCare === '0') {
        return this.showMessage('Atenção!', 'Selecione um tipo de atendimento.')
      }

      //
      // Deve selecionar o COMPARECIMENTO
      //

      // if (this.patientSelected === true && this.fieldPatientAttendance === '') return this.showMessage('Atenção!', 'Selecione o status do comparecimento.')

      //
      // Deve selecionar uma UNIDADE DE ATENDIMENTO válida para o paciente quando o TIPO DE CONSULTA é PRESENCIAL
      //

      if (
        this.patientSelected === true &&
        this.activePatient.fieldTypeOfMedicalCare === '1' &&
        (
          this.activePatient.fieldPatientUnitId === '' ||
          (
            this.activePatient.fieldPatientUnitId !== '' &&
            String(this.activePatient.fieldPatientUnitName).trim().length === 0
          )
        )
      ) {
        return this.showMessage('Atenção!', 'Selecione uma unidade de atendimento VÁLIDA para o(a) paciente.')
      }

      //
      //
      //
      // Atualizar consulta com paciente
      //
      //
      //

      if (this.patientSelected === true)
      {
        // const patientName = this.activePatient.currentPatientName // buildPatientName(patientFirstName, patientLastName)

        // Try to get patient profile
        this.isLoading = true
        const request = await apiGetPatient({ viewerID: apiGetUserId(), patientID: this.fieldPatientId, groupID: this.$route.params.groupID })
        this.isLoading = false

        // It wasn't possible to get patient profile
        if (request.httpCode !== 200) return this.showMessage(request.title, request.message)

        // Stop here and continue in "confirmDialog > confirm"
        const patientUnitAddress = this.activePatient.fieldTypeOfMedicalCare === '1' ? buildPatientUnitAddress({
          unitName: this.activePatient.fieldPatientUnitName,
          unitAddress: this.activePatient.fieldPatientUnitAddress,
        }) : []
        const patientProfile = buildPatientLocation(request.message)

        const patientName = this.activePatient.currentPatientName
        const message = buildPatientLocationMessage(patientName, patientUnitAddress, patientProfile)

        return this.showConfirmBox({
          title: 'Atenção!',
          text: message,
          type: 'confirm',
          data: '',
          isResponse: false,
          buttonPosition: 'right',
          width: 480,
          closeText: 'Voltar',
          continueText: 'Sim, atualize a consulta!',
        })
      }

      //
      //
      //
      // Paciente foi removido e a consulta será desmarcada
      //
      //
      //

      if (this.withPatient === true && this.patientSelected === false)
      {
        return this.showConfirmBox({
          title: 'Atenção!',
          text: `Você está prestes a desmarcar a consulta com <b style="color: indianred">${this.defaultPatient.currentPatientName}</b>!<br /><br /><b>Você deseja continuar?</b><br /><br /><b style="color: indianred">ATENÇÃO</b>: <span style="color: dodgerblue">Você pode clicar em VOLTAR e fechar os detalhes da consulta para cancelar esse processo</span>.`,
          type: 'confirm_patient_detachment',
          data: '',
          isResponse: false,
          buttonPosition: 'right',
          width: 480,
          closeText: 'Voltar',
          continueText: 'Atualizar',
        })
      }

      //
      //
      //
      // Atualizando uma consulta sem paciente
      // Essa consulta não tem paciente
      //
      //
      //

      const payload = {
        operation: 'UPDATE_NO_PATIENT',

        viewerID: apiGetUserId(),
        consultationID: this.consultationID,
        ownerID: this.campoPlantonistaSelecionado,
        startTimestamp: this.startTimestamp,
        obs: this.cleanedObs,

        /*
        // Tratamento para CONSULTA SEM PACIENTE (PACIENTE NÃO OBRIGATÓRIO) QUE CONTINUA SEM PACIENTE E ALTEROU OUTROS DADOS: Município ou Observação
        patientAttendance: !!this.activePatient === true ? this.activePatient.fieldPatientAttendance : '',

        doctor: !!this.activePatient.fieldDoctorProfile === true ? {
          id: this.activePatient.fieldDoctorProfile.id || '',
          name: this.activePatient.fieldDoctorProfile.name || '',
        } : null,
        */
      }

      this.isLoading = true
      const x = await apiUpdateAppointment(payload)
      this.isLoading = false

      this.showDialog(x.code === 0 ? 'Atenção!' : 'Feito!', x.message, 'close', '', true, 'right', 400, true)
    },

    //
    //
    //
    // ?
    //
    //
    //

    deleteConsultation ()
    {
      if (this.isLoading) return false

      this.showDialogWithPassword('Atenção!', 'A consulta será <b style="color: orangered">apagada permanentemente</b> do sistema e dos relatórios. <b>Deseja continuar?</b>', 'delete-consultation', '', false, 'right', 400, false, 'demanda1234')
    },

    //
    //
    //
    // ?
    //
    //
    //

    async confirmDialog (cdResponse)
    {
      if (cdResponse === false) return false

      //
      //
      //
      // Fechar a janela
      //
      //
      //

      if (cdResponse.cdType === 'close')
      {
        this.closeDialog()
      }

      //
      //
      //
      // ATUALIZAR CONSULTA COM PACIENTE
      //
      //
      //

      if (cdResponse.cdType === 'confirm')
      {
        // NÃO CONTINUA O PROCESSAMENTO SE ESTIVER EXECUTANDO ALGUMA OPERAÇÃO
        if (this.isLoading) return false

        const operation = this.withPatient === true && this.changedPatient === false ? (
          // Consulta tinha paciente, continua com paciente e esse paciente não foi alterado
          // Exemplo: Alterou o município
          'CONSULTATION_UPDATED'
        ) : (
          this.withPatient === true && this.changedPatient === true ? (
            // Consulta tinha paciente, continua com paciente e esse paciente foi alterado (Obs: Remoção de paciente?)
            'PATIENT_CHANGED'
          ) : (
            this.withPatient === false ? (
              // Consulta não tinha paciente e agora o paciente foi inserido
              'PATIENT_SET'
            ) : (
              // JESUS: Consulta sem paciente e alterada? É possível?
              'UNKNOWN'
            )
          )
        )

        if (operation === 'UNKNOWN') return false

        const payload = {
          operation, // ALL

          viewerID: apiGetUserId(),
          consultationID: this.consultationID, // ALL
          ownerID: this.campoPlantonistaSelecionado, // ALL
          startTimestamp: this.startTimestamp, // ALL
          obs: this.cleanedObs, // ALL

          selectedTypeOfMedicalCare: this.activePatient.fieldTypeOfMedicalCare,
          defaultTypeOfMedicalCare: this.defaultPatient.fieldTypeOfMedicalCare,

          // regulationCode: String(this.activePatient.fieldRegulationCode || '').trim(),
          // confirmationKey: String(this.activePatient.fieldConfirmationKey || '').trim(),

          patientId: this.fieldPatientId,
          patientAttendance: this.activePatient.fieldPatientAttendance, // ALL
          patientProfile: {
            firstName: String(this.activePatient.patientFirstName).trim(),
            lastName: String(this.activePatient.patientLastName).trim(),
            dateOfBirth: String(this.activePatient.patientDateOfBirth).trim(),
            email: String(this.activePatient.patientEmail).trim(),
            cpf: String(this.activePatient.patientCpf).trim(),
            group: String(this.activePatient.patientGroup).trim(),
          },

          reminderId: this.reminderId,
          reminder: /* this.activePatient.fieldTypeOfMedicalCare === '1' ? */ {
            consultation_date: this.consultationDate,
            consultation_start_time: `${this.consultationStartTime}:00`,
            consultation_end_time: `${this.consultationEndTime}:00`,
            unit_id: this.activePatient.fieldPatientUnitId,
            unit_name: String(this.activePatient.fieldPatientUnitName || '').trim(),
            unit_address: String(this.activePatient.fieldPatientUnitAddress || '').trim(),
            specialty_id: this.plantaoEscalaID,
            specialty_name: String(this.plantaoEscalaNome || '').trim(),
          }/*  : (
            'detach'
          ) */,

          currentPatientName: String(this.activePatient.currentPatientName || '').trim(),
          // currentPatientId: this.fieldPatientId || '',
          previousPatientName: String(this.defaultPatient.currentPatientName || '').trim(),
          previousPatientId: this.backupPatientId || '',

          // ALL
          doctor: !!this.activePatient.fieldDoctorProfile === true ? {
            id: this.activePatient.fieldDoctorProfile.id || '',
            name: this.activePatient.fieldDoctorProfile.name || '',
          } : null,
        }

        //
        // VERIFICAR OBRIGATORIEDADE DOS CAMPOS DE CHAVE
        //

        if (this.requireSosPortalAppointmentKeys) {
          payload.regulationCode = String(this.activePatient.fieldRegulationCode || '').trim()
          payload.confirmationKey = String(this.activePatient.fieldConfirmationKey || '').trim()
        }

        //
        // AVISA A UI QUE COMEÇOU A PROCESSAR, EXECUTA A ATUALIZAÇÃO E AVISA A UI QUE TERMINOU DE PROCESSAR
        //

        this.isLoading = true
        const x = await apiUpdateAppointment(payload)
        this.isLoading = false

        //
        // RESPOSTA
        //

        if (x.code === 0) {
          return this.showMessage(x.title, x.message)
        } else {
          return this.showDialog(x.title, x.message, 'close', '', true, 'right', 400, true)
        }
      }

      //
      //
      //
      // Remover paciente
      // JESUS: Informar nos detalhes da consulta, se o reminder continua ativo ou não (após erro)
      //
      //
      //

      if (cdResponse.cdType === 'confirm_patient_detachment')
      {
        // NÃO CONTINUA O PROCESSAMENTO SE ESTIVER EXECUTANDO ALGUMA OPERAÇÃO
        if (this.isLoading) return false

        const payload = {
          operation: 'DETACH_PATIENT_AND_UPDATE',

          viewerID: apiGetUserId(),
          consultationID: this.consultationID,
          ownerID: this.campoPlantonistaSelecionado,
          startTimestamp: this.startTimestamp,
          obs: this.cleanedObs,

          currentPatientName: String(this.activePatient.currentPatientName || '').trim(),
          previousPatientName: String(this.defaultPatient.currentPatientName || '').trim(),
        }

        // AVISA A UI QUE COMEÇOU A PROCESSAR, EXECUTA A ATUALIZAÇÃO E AVISA A UI QUE TERMINOU DE PROCESSAR
        this.isLoading = true
        const x = await apiUpdateAppointment(payload)
        this.isLoading = false

        // RESPOSTA
        if (x.code === 0) {
          return this.showMessage(x.title, x.message)
        } else {
          return this.showDialog(x.title, x.message, 'close', '', true, 'right', 400, true)
        }
      }

      //
      //
      //
      // Apagar consulta
      //
      //
      //

      if (cdResponse.cdType === 'delete-consultation')
      {
        // const consultationID = cdResponse.cdData

        // NÃO CONTINUA O PROCESSAMENTO SE ESTIVER EXECUTANDO ALGUMA OPERAÇÃO
        if (this.isLoading) return false

        const payload = {
          viewerID: apiGetUserId(),
          consultationID: this.consultationID,
        }

        // AVISA A UI QUE COMEÇOU A PROCESSAR, APAGA A CONSULTA E AVISA A UI QUE TERMINOU DE PROCESSAR
        this.isLoading = true
        const x = await apiDeleteAppointment(payload)
        this.isLoading = false

        // RESPOSTA
        if (x.code === 0) {
          return this.showMessage(x.title, x.message)
        } else {
          return this.showDialog(x.title, x.message, 'close', '', true, 'right', 400, true)
        }
      }
    },

    //
    //
    //
    // AFTER SELECTING THE PATIENT
    //
    //
    //

    async findPatientAction (cdResponse)
    {
      // console.log('::: DETALHES DA CONSULTA - cdResponse:', cdResponse)

      const pId = String(cdResponse.patientId || '')
      const patient = !!pId === true && !!this.patients[pId] === true

      if (patient) {
        this.updatePatientProfile(pId, cdResponse)
      } else {
        this.createPatientProfile(pId, cdResponse)
      }

      this.fieldPatientId = pId

      this.requireSosPortalAppointmentKeys = this.$store.state?.group?.requireSosPortalAppointmentKeys || false

      // FETCH / RETRIEVE PATIENT DOCTORS FOR SPECIALTY
      await this.refreshPatientDoctors(pId, this.plantaoEscalaID)

      // DEBUG
      // console.log('::: [findPatientAction] SELECTED PATIENT ID + PATIENTS LIST:', patient, this.fieldPatientId, this.patients)
    },

    //
    //
    //
    // RESTORE DEFAULT PATIENT
    //
    //
    //

    restoreDefaultPatient () {
      if (!!this.backupPatientId === false) return false

      this.fieldPatientId = this.backupPatientId
    },

    //
    //
    //
    // ?
    //
    //
    //

    onSelectTypeOfMedicalCare (optionValue)
    {
      this.setCurrentPatientTypeOfMedicalCare(optionValue)
    },

    //
    //
    //
    // ?
    //
    //
    //

    onSelectPatientAttendanceStatus (optionValue)
    {
      this.setCurrentPatientAttendanceStatus(optionValue)
    },

    //
    //
    //
    // HANDLE PATIENT PROFILE
    //
    //
    //

    createPatientProfile (patientID, patientData)
    {
      // if (!!this.patients[patientID] === false) return false

      const patientFirstName = patientData.patientFirstName || ''
      const patientLastName = patientData.patientLastName || ''

      this.patients[patientID] = {
        patientFirstName,
        patientLastName,
        patientDateOfBirth: patientData.patientDateOfBirth || '',
        patientEmail: patientData.patientEmail || '',
        patientCpf: patientData.patientCpf || '',
        patientGroup: patientData.patientGroup || '',
        // patientGroup: !!args.consultation.patient === true && !!args.consultation.patient.group === true ? args.consultation.patient.group : '',

        currentPatientName: buildPatientName(patientFirstName, patientLastName),

        //

        fieldRegulationCode: '',
        fieldConfirmationKey: '',

        fieldTypeOfMedicalCare: '0',
        fieldPatientUnitId: '',
        fieldPatientUnitName: '',
        fieldPatientUnitAddress: '',
        fieldPatientAttendance: '',
        fieldDoctorId: '',
        fieldDoctorName: optionDefault,
        fieldDoctorProfile: null,

        //

        doctorsStatus: 'WAITING',
        doctorsStatusMessage: '',
        selectDoctors: [optionAny],
        fieldDoctorError: false,

        //

        backupRegulationCode: '',
        backupConfirmationKey: '',

        backupTypeOfMedicalCare: '0',
        backupPatientUnitId: '',
        backupPatientUnitName: '',
        backupPatientUnitAddress: '',
        backupPatientAttendance: '',
        backupDoctorId: '',
        backupDoctorProfile: null,
      }

      this.patients = { ...this.patients }
    },

    updatePatientProfile (patientID, patientData)
    {
      if (!!this.patients[patientID] === false) return false

      const patientFirstName = patientData.patientFirstName || ''
      const patientLastName = patientData.patientLastName || ''

      this.patients[patientID] = {
        ...this.patients[patientID],

        patientFirstName: patientFirstName,
        patientLastName: patientLastName,
        patientDateOfBirth: patientData.patientDateOfBirth || '',
        patientEmail: patientData.patientEmail || '',
        patientCpf: patientData.patientCpf || '',
        patientGroup: patientData.patientGroup || '',

        currentPatientName: buildPatientName(patientFirstName, patientLastName),
      }

      this.patients = { ...this.patients }
    },

    setCurrentPatientTypeOfMedicalCare (status)
    {
      if (!!this.patients[this.fieldPatientId] === false) return false

      this.patients[this.fieldPatientId].fieldTypeOfMedicalCare = status

      this.patients = { ...this.patients }

      // console.log('::: setCurrentPatientTypeOfMedicalCare:', this.patients[this.fieldPatientId].fieldTypeOfMedicalCare)
    },

    setCurrentPatientAttendanceStatus (status)
    {
      if (!!this.patients[this.fieldPatientId] === false) return false

      this.patients[this.fieldPatientId].fieldPatientAttendance = status

      this.patients = { ...this.patients }

      // console.log('::: setCurrentPatientAttendanceStatus:', this.patients[this.fieldPatientId].fieldPatientAttendance)
    },

    /* fieldTypeOfMedicalCare: function () {
      return !!this.activePatient === true && !!this.activePatient.fieldTypeOfMedicalCare === true ? this.activePatient.fieldTypeOfMedicalCare : ''
    },

    fieldPatientAttendance: function () {
      return !!this.activePatient === true && !!this.activePatient.fieldPatientAttendance === true ? this.activePatient.fieldPatientAttendance : ''
    }, */

    onDoctorSelect (optionValue)
    {
      if (!!this.fieldPatientId === false || !!this.patients[this.fieldPatientId] === false) return false

      const foundDoctor = this.patients[this.fieldPatientId].selectDoctors.find(d => d.value === optionValue)
      const backupDoctorFound = !!this.patients[this.fieldPatientId].backupDoctorId === true && !!this.patients[this.fieldPatientId].backupDoctorProfile === true
      const backupDoctorSelected = backupDoctorFound && this.patients[this.fieldPatientId].backupDoctorId === optionValue

      // console.log('::: ON DOCTOR SELECT > optionValue:', optionValue, foundDoctor)

      const doctorFound = !!optionValue === true && !!foundDoctor === true
      const doctorSelected = !!this.patients[this.fieldPatientId].backupDoctorId === true && this.patients[this.fieldPatientId].backupDoctorId === String(foundDoctor?.profile?.id || '')

      // JESUS: Testar mais
      const icon = doctorFound ? (foundDoctor?.profile?.last || doctorSelected ? 'stethoscope' : 'account') : (backupDoctorFound ? (backupDoctorSelected ? 'stethoscope' : 'account') : 'account-group')
      const iconColor = doctorFound ? (foundDoctor?.profile?.last ? ' appointmentdoctor__item__icon--active' : ' appointmentdoctor__item__icon--normal') : (backupDoctorFound ? (/* backupDoctorSelected ? ' appointmentdoctor__item__icon--active' : */ ' appointmentdoctor__item__icon--normal') : '')
      const textColor = doctorFound ? (foundDoctor?.profile?.last ? ' appointmentdoctor__item__text--active' : ' appointmentdoctor__item__text--normal') : (backupDoctorFound ? (/* backupDoctorSelected ? ' appointmentdoctor__item__text--active' : */ ' appointmentdoctor__item__text--normal') : '')
      const doctorName = doctorFound && doctorSelected ? `${foundDoctor?.profile?.name} (<span class="itemTextBold">Atual</span>)` : (backupDoctorFound ? (backupDoctorSelected ? `${this.patients[this.fieldPatientId].backupDoctorProfile?.name} (<span class="itemTextBold">Atual</span>)` : this.patients[this.fieldPatientId].backupDoctorProfile?.name) : '')
      const name = doctorFound ? (foundDoctor?.profile?.last ? `${doctorName} (<span class="itemTextBold">Último atendimento</span>)` : doctorName) : (backupDoctorFound ? (backupDoctorSelected ? doctorName : doctorName) : 'Qualquer profissional (<span class="itemTextBold">Opção padrão</span>)')

      //

      // JESUS: Testar mais
      this.patients[this.fieldPatientId].fieldDoctorId = optionValue
      this.patients[this.fieldPatientId].fieldDoctorName = `<div class="appointmentdoctor__item"><i aria-hidden="true" class="mdi mdi-${icon} appointmentdoctor__item__icon${iconColor}"></i><span class="appointmentdoctor__item__text${textColor}">${name}</span></div>`
      this.patients[this.fieldPatientId].fieldDoctorProfile = doctorFound ? (foundDoctor?.profile || null) : (backupDoctorFound /* && backupDoctorSelected */ ? this.patients[this.fieldPatientId].backupDoctorProfile : null)

      this.patients = { ...this.patients }

      // console.log('::: ON DOCTOR SELECT:', { fieldDoctorId: this.patients[this.fieldPatientId].fieldDoctorId || 'ERROR', fieldDoctorName: this.patients[this.fieldPatientId].fieldDoctorName || 'ERROR', fieldDoctorProfile: this.patients[this.fieldPatientId].fieldDoctorProfile || 'ERROR' })
    },
  },
}
